<template>
    <div
        v-if="show"
        class="notification"
        :class="[background ? `is-${background}` : '' ]"
    >
        <div class="notification-content">
            <slot />
        </div>
        <div v-if="dissmissable" class="close-notification">
            <i
                class=" far fa-times"
                @click="hide"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    props: {
        dissmissable: {
            type: Boolean,
            default: true,
        },
        cookieName: {
            type: [String, Boolean],
            default: false,
        },
        background: {
            type: [String, Boolean],
            default: false,
        },
    },

    data: () => ({
        show: true,
    }),

    computed: {
        ...mapState(['user']),
    },

    /**
     * Created hook
     */
    created() {
        if (this.cookieName) {
            const cookie = this.$cookies.get(this.cookieName);
            let initialized = false;

            for (const meta of this.user.metas) {
                initialized = `${this.cookieName}_initialized` === meta?.key;
            }

            if (cookie) {
                this.$emit('showing-user-notification');
                return;
            }

            if (! cookie && ! initialized) {
                this.$cookies.set(this.cookieName, true, '1m');
                this.setUserMeta({ [`${this.cookieName}_initialized`]: true });
            }

            if (initialized && ! cookie) {
                this.hide();
            }
        }
    },

    methods: {
        ...mapActions(['setUserMeta']),

        /**
         * Hides notification
         */
        hide() {
            this.show = false;
            this.$emit('hide-user-notification');
        },
    },
};
</script>
